var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from "./cn";
var classes = {
    error: "bg-background-error border text-content-error",
    instructions: "border bg-background-warning text-content-warning",
    upsell: "border border-util-accent max-w-prose bg-util-accent/10",
    localDev: "bg-teal-100 border border-teal-500 dark:bg-teal-900 text-content-primary",
};
export function Callout(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "instructions" : _b, children = _a.children, className = _a.className, props = __rest(_a, ["variant", "children", "className"]);
    return (<div className={cn("flex mt-2 px-3 py-2 rounded text-sm ".concat(classes[variant]), className)} role="alert" {...props}>
      {children}
    </div>);
}
